<script lang="ts" setup>
import { computed } from "vue";
import { XIcon, CheckIcon } from "@heroicons/vue/solid";

interface WhiseDetail {
    id: number;
    label: string;
    type: "year" | "yes/no" | "length" | "environment" | "heating" | "kitchen" | "ground_destination" | "ElecCertifConformity" | "float" | "char";
    value: string;
    group: string;
}

const props = defineProps<{ details: WhiseDetail[] }>();

const displayGroup: string[] = ["Juridisch", "Energie", "Certificaten", "Omgeving"];

const filteredDetails = computed(() => {
    return props.details
        .filter((d: WhiseDetail) => displayGroup.includes(d.group))
        .reduce((d: { [key: string]: WhiseDetail[] }, wDetail) => {
            const { group } = wDetail;
            d[group] = d[group] ?? [];
            d[group].push(wDetail);
            return d;
        }, {});
});
</script>

<template>
    <div class="flex flex-col">
        <h3 v-if="filteredDetails.length">Nuttige info</h3>
        <template v-for="(group, groupName) in filteredDetails">
            <!-- <div class="font-medium col-span-1 lg:col-span-2 mb-[8px] mt-[32px]">{{ groupName }}</div> -->
            <div v-for="detail in group.filter((g) => !['Type buurt', 'terrein - bestemming', 'Type buurt 2'].includes(g.label))" class="flex flex-row justify-between text-14 mb-[8px] gap-x-[8px] w-full">
                <span class="font-medium flex-none w-[200px] whitespace-nowrap">{{ detail.label }}</span>
                <div class="text-right">
                    <span v-if="detail.type === 'yes/no'">
                        <CheckIcon v-if="detail.value === '1'" class="h-[20px] text-brown-200"></CheckIcon>
                        <XIcon v-else class="h-[20px] text-brown-200"></XIcon>
                    </span>
                    <span v-else-if="detail.value === 'ja, conform'"><CheckIcon class="h-[20px] text-brown-200"></CheckIcon></span>
                    <span v-else class="word-break">{{ detail.value }}</span>
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped>
.word-break {
    word-break: break-word;
}
</style>
